import { STRAIGHT_MAN_CATEGORY } from '@/constants';

import { HARDCODED_CATEGORIES } from '../../OwnAIMan/constants';

import type { IdentifiesRomanticallyOptionIdType } from '../types';

export interface OrientationCategoriesResult {
  categories: string[];
  first_categories: string[];
}

export function getOrientationCategories(
  gender: 'male' | 'female' | null,
  identifiesRomantically: IdentifiesRomanticallyOptionIdType | null,
): OrientationCategoriesResult | null {
  if (gender !== 'male') {
    return null;
  }

  if (!identifiesRomantically) {
    return null;
  }

  if (identifiesRomantically === 'gay') {
    return {
      categories: [...HARDCODED_CATEGORIES],
      first_categories: [...HARDCODED_CATEGORIES],
    };
  }

  if (identifiesRomantically === 'straight') {
    return {
      categories: [STRAIGHT_MAN_CATEGORY],
      first_categories: [STRAIGHT_MAN_CATEGORY],
    };
  }

  return {
    categories: [...HARDCODED_CATEGORIES, STRAIGHT_MAN_CATEGORY],
    first_categories: [...HARDCODED_CATEGORIES, STRAIGHT_MAN_CATEGORY],
  };
}
